// Fancybox initialization
window.addEventListener('load', function() {
  if (typeof Fancybox !== 'undefined') {
    try {
      // Unbind any existing fancybox instances to prevent conflicts
      Fancybox.unbind("[data-fancybox]");
      
      // IMPORTANT: Bind SKU gallery FIRST with custom caption before the general binding
      // Specific initialization for SKU gallery with custom caption and Add to Cart
      Fancybox.bind('[data-fancybox="sku-gallery"], [data-fancybox="sku-gallery-mobile"]', {
        Images: {
          zoom: true
        },
        Toolbar: {
          display: {
            left: ["close"],
            middle: ["prev", "counter", "next"],
            right: ["zoom", "slideshow", "fullscreen", "download"]
          }
        },
        // Generate caption HTML directly from slide data
        caption: function(fancybox, slide) {
          // Get variant data from the trigger element
          const el = slide.triggerEl || slide.el;
          if (!el) return '';
          
          const variantTitle = el.getAttribute('data-variant-title') || el.getAttribute('data-caption');
          const variantId = el.getAttribute('data-variant-id');
          const variantPrice = el.getAttribute('data-variant-price');
          const variantAvailable = el.getAttribute('data-variant-available') === 'true';
          
          if (!variantTitle) return '';
          
          // Create caption HTML with title on left, price and button on right
          let captionHTML = `
            <div class="fancybox-custom-caption">
              <div class="fancybox-caption-info">
                <div class="fancybox-variant-title">${variantTitle}</div>
              </div>
              <div class="fancybox-caption-actions">
                <div class="fancybox-variant-price">${variantPrice}</div>`;
          
          if (variantAvailable) {
            captionHTML += `
                <button class="fancybox-add-to-cart-btn" data-variant-id="${variantId}">
                  Add to Cart
                </button>`;
          } else {
            captionHTML += `
                <button class="fancybox-add-to-cart-btn" disabled>
                  Out of Stock
                </button>`;
          }
          
          captionHTML += `
              </div>
            </div>`;
          
          return captionHTML;
        },
        showClass: "f-fadeIn",
        hideClass: "f-fadeOut",
        on: {
          ready: function(fancybox) {
            console.log('SKU Gallery Fancybox Ready Event Triggered');
            // Attach click handlers to Add to Cart buttons
            attachAddToCartHandlers(fancybox);
            // Match caption width to content width
            matchCaptionWidth(fancybox);
          },
          reveal: function(fancybox, slide) {
            console.log('SKU Gallery Fancybox Reveal Event Triggered for slide', slide.index);
            // Reattach handlers when slide changes
            attachAddToCartHandlers(fancybox);
            // Match caption width to content width
            matchCaptionWidth(fancybox);
          },
          done: function(fancybox, slide) {
            // Also match on done event when image is fully loaded
            matchCaptionWidth(fancybox);
          }
        }
      });

      // Helper function to attach click handlers to Add to Cart buttons
      function attachAddToCartHandlers(fancybox) {
        console.log('Attaching Add to Cart handlers');
        
        // Find the fancybox container
        const container = fancybox.container || fancybox.$container || document.querySelector('.fancybox__container');
        if (!container) {
          console.error('Could not find fancybox container');
          return;
        }
        
        // Find all Add to Cart buttons in captions
        const addToCartButtons = container.querySelectorAll('.fancybox-add-to-cart-btn:not([disabled])');
        console.log('Found', addToCartButtons.length, 'Add to Cart buttons');
        
        addToCartButtons.forEach(function(button) {
          // Remove any existing listeners by cloning and replacing
          const newBtn = button.cloneNode(true);
          button.parentNode.replaceChild(newBtn, button);
          
          // Add click handler
          newBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const variantId = this.getAttribute('data-variant-id');
            const originalText = this.textContent;

            // Show loading state
            this.textContent = 'Adding...';
            this.disabled = true;

            // Add to cart
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');

            fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            })
            .then(response => response.json())
            .then(data => {
              console.log('Successfully added to cart:', data);
              // Show success state
              this.textContent = 'Added!';
              setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
              }, 2000);
            })
            .catch(error => {
              console.error('Error adding to cart:', error);
              this.textContent = 'Error';
              setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
              }, 2000);
            });
          });
        });
        
        console.log('Click handlers attached to all Add to Cart buttons');
      }
      
      // Helper function to match caption width to content width
      function matchCaptionWidth(fancybox) {
        console.log('Matching caption width to content width');
        
        // Find the fancybox container
        const container = fancybox.container || fancybox.$container || document.querySelector('.fancybox__container');
        if (!container) {
          console.error('Could not find fancybox container for width matching');
          return;
        }
        
        // Find ALL content elements (there may be multiple slides)
        const contentElements = container.querySelectorAll('.fancybox__content');
        const captionElements = container.querySelectorAll('.fancybox__caption');
        
        if (contentElements.length === 0 || captionElements.length === 0) {
          console.log('Content or caption elements not found for width matching');
          return;
        }
        
        // Function to set width for a single caption based on its content
        const setWidthForCaption = (content, caption) => {
          const contentWidth = content.offsetWidth;
          
          if (contentWidth > 0) {
            // Set the caption width to match the content width
            caption.style.width = contentWidth + 'px';
            caption.style.maxWidth = contentWidth + 'px';
            console.log('Caption width set to:', contentWidth + 'px');
            return true;
          }
          return false;
        };
        
        // Match each caption to its corresponding content
        // Typically Fancybox has one caption for all slides, but let's handle both cases
        if (captionElements.length === 1 && contentElements.length >= 1) {
          // Single caption for all slides - match to the active/visible content
          const activeContent = container.querySelector('.fancybox__slide.is-selected .fancybox__content') || 
                                container.querySelector('.fancybox__content');
          const caption = captionElements[0];
          
          if (activeContent && caption) {
            if (!setWidthForCaption(activeContent, caption)) {
              // If content width is 0, try again after a short delay
              setTimeout(() => {
                setWidthForCaption(activeContent, caption);
              }, 100);
            }
          }
        } else {
          // Multiple captions - match each to its content
          contentElements.forEach((content, index) => {
            if (captionElements[index]) {
              if (!setWidthForCaption(content, captionElements[index])) {
                // If content width is 0, try again after a short delay
                setTimeout(() => {
                  setWidthForCaption(content, captionElements[index]);
                }, 100);
              }
            }
          });
        }
      }
      
      // Bind variant galleries (2-5 SKU variant images) with same caption and Add to Cart
      Fancybox.bind('[data-fancybox^="variant-gallery"]', {
        Images: {
          zoom: true
        },
        Toolbar: {
          display: {
            left: ["close"],
            middle: ["prev", "counter", "next"],
            right: ["zoom", "slideshow", "fullscreen", "download"]
          }
        },
        // Generate caption HTML directly from slide data
        caption: function(fancybox, slide) {
          // Get variant data from the trigger element
          const el = slide.triggerEl || slide.el;
          if (!el) return '';
          
          const variantTitle = el.getAttribute('data-variant-title') || el.getAttribute('data-caption');
          const variantId = el.getAttribute('data-variant-id');
          const variantPrice = el.getAttribute('data-variant-price');
          const variantAvailable = el.getAttribute('data-variant-available') === 'true';
          
          if (!variantTitle) return '';
          
          // Create caption HTML with title on left, price and button on right
          let captionHTML = `
            <div class="fancybox-custom-caption">
              <div class="fancybox-caption-info">
                <div class="fancybox-variant-title">${variantTitle}</div>
              </div>
              <div class="fancybox-caption-actions">
                <div class="fancybox-variant-price">${variantPrice}</div>`;
          
          if (variantAvailable) {
            captionHTML += `
                <button class="fancybox-add-to-cart-btn" data-variant-id="${variantId}">
                  Add to Cart
                </button>`;
          } else {
            captionHTML += `
                <button class="fancybox-add-to-cart-btn" disabled>
                  Out of Stock
                </button>`;
          }
          
          captionHTML += `
              </div>
            </div>`;
          
          return captionHTML;
        },
        showClass: "f-fadeIn",
        hideClass: "f-fadeOut",
        on: {
          ready: function(fancybox) {
            console.log('Variant Gallery Fancybox Ready Event Triggered');
            // Attach click handlers to Add to Cart buttons
            attachAddToCartHandlers(fancybox);
            // Match caption width to content width
            matchCaptionWidth(fancybox);
          },
          reveal: function(fancybox, slide) {
            console.log('Variant Gallery Fancybox Reveal Event Triggered for slide', slide.index);
            // Reattach handlers when slide changes
            attachAddToCartHandlers(fancybox);
            // Match caption width to content width
            matchCaptionWidth(fancybox);
          },
          done: function(fancybox, slide) {
            // Also match on done event when image is fully loaded
            matchCaptionWidth(fancybox);
          }
        }
      });
      
      // NOW bind the general fancybox for everything else (excluding sku-gallery and variant-gallery which are already bound)
      // Initialize with proper configuration for other galleries
      Fancybox.bind('[data-fancybox]:not([data-fancybox="sku-gallery"]):not([data-fancybox="sku-gallery-mobile"]):not([data-fancybox^="variant-gallery"])', {
        // Custom options
        Images: {
          zoom: true
        },
        Toolbar: {
          display: {
            left: ["close"],
            middle: ["prev", "counter", "next"],
            right: ["zoom", "slideshow", "fullscreen", "download"]
          }
        },
        // Fix for "i[t] is not iterable" error
        on: {
          initLayout: function(fancybox) {
            // Ensure proper data structure for slides
            if (fancybox && fancybox.items) {
              fancybox.items.forEach(function(item) {
                // Ensure item has proper structure
                if (!item.src && item.el) {
                  item.src = item.el.getAttribute('href');
                }
                if (!item.type) {
                  item.type = 'image';
                }
                
                // Use caption from data-caption attribute if available
                if (item.el && item.el.getAttribute('data-caption')) {
                  item.caption = item.el.getAttribute('data-caption');
                }
              });
            }
          }
        }
      });
      
      // Specific initialization for product gallery
      Fancybox.bind('[data-fancybox="product-gallery"]', {
        groupAll: true,
        Images: {
          zoom: true
        },
        Toolbar: {
          display: {
            left: ["close"],
            middle: ["prev", "counter", "next"],
            right: ["zoom", "slideshow", "fullscreen", "download"]
          }
        },
        on: {
          initLayout: function(fancybox) {
            if (fancybox && fancybox.items) {
              fancybox.items.forEach(function(item) {
                if (!item.src && item.el) {
                  item.src = item.el.getAttribute('href');
                }
                if (!item.type) {
                  item.type = 'image';
                }
                if (item.el && item.el.getAttribute('data-caption')) {
                  item.caption = item.el.getAttribute('data-caption');
                }
              });
            }
          }
        }
      });
      
      // Log successful initialization
      console.log("Fancybox initialized successfully");
    } catch (error) {
      console.error("Error initializing Fancybox:", error);
    }
  } else {
    console.warn("Fancybox not available");
  }
}); 